module.exports = __webpack_public_path__ + "img/gemina.ab417ce4.jpg";